import { GxMenuItem } from '@garpix/garpix-web-components-react'
import classNames from 'classnames'
import React from 'react'
import style from './styles/item.module.scss'

const SelectItem = ({
  children,
  value,
  className = '',
  theme = 'gray',
  ...props
}): React.ReactElement => {
  return (
    <GxMenuItem
      value={value}
      className={classNames({
        [style.default]: true,
        [style[`theme_${theme}`]]: Boolean(theme),
        [className]: className
      })}
      {...props}
    >
      {children}
    </GxMenuItem>
  )
}

export default SelectItem
